import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-698cd376"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "width", "height"]
const _hoisted_2 = { class: "game-over-btn-container" }
const _hoisted_3 = { class: "end__progress-bar" }

import { useUserStore } from '@/stores/userStore';

import ProgressComponent from '@/components/ProgressComponent.vue';
import IconComponent from '@/components/IconComponent.vue';
import DividerComponent from '@/components/DividerComponent.vue';
import IconLogo from '@/assets/VueIcons/IconLogo.vue';
import IconTable from '@/assets/VueIcons/IconTable.vue';
import IconLineChart from '@/assets/VueIcons/IconLineChart.vue';
import IconPalette from '@/assets/VueIcons/IconPalette.vue';
import router from '@/router';
import { ROUTES } from '@/router/routes';
import { useGameStore } from '@/stores/gameStore';
import EndLayoutComponent from '@/components/EndLayoutComponent.vue';
import { isPhone } from '@/utils/responsiveHelper';


export default /*#__PURE__*/_defineComponent({
  __name: 'GameEndMenuView',
  setup(__props) {

const userStore = useUserStore();
const gameStore = useGameStore();

const handleNewGame = () => {
  userStore.resetUserState();
  gameStore.resetGameStateForNewGame();

  router.push(ROUTES.START);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("img", {
      src: require('@/assets/images/moaf-logo.svg'),
      width: _unref(isPhone)() ? '100' : '245',
      height: _unref(isPhone)() ? '100' : '245',
      alt: "logo",
      class: "icon-wrapper"
    }, null, 8, _hoisted_1),
    _createVNode(EndLayoutComponent, { class: "layout" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push(_unref(ROUTES).LEADERBOARD))),
            class: "secondary-button button"
          }, [
            _createTextVNode(" Hall Of Fame "),
            _createVNode(IconComponent, null, {
              default: _withCtx(() => [
                _createVNode(IconTable)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("button", {
            class: "secondary-button button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (
          _unref(isPhone)()
            ? _ctx.$router.push(_unref(ROUTES).ANALYSIS_MOBILE)
            : _ctx.$router.push(_unref(ROUTES).ANALYSIS)
        ))
          }, [
            _createTextVNode(" Game Analysis "),
            _createVNode(IconComponent, null, {
              default: _withCtx(() => [
                _createVNode(IconLineChart)
              ]),
              _: 1
            })
          ]),
          _createVNode(DividerComponent, null, {
            default: _withCtx(() => [
              _createTextVNode(" OR ")
            ]),
            _: 1
          }),
          _createElementVNode("button", {
            class: "primary-button button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (handleNewGame()))
          }, [
            _createTextVNode(" Play Again "),
            _createVNode(IconComponent, null, {
              default: _withCtx(() => [
                _createVNode(IconPalette)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(ProgressComponent, {
            filled: "",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push(_unref(ROUTES).GAME_OVER)))
          }),
          _createVNode(ProgressComponent, {
            filled: "",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push(_unref(ROUTES).END_MENU)))
          })
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})